import {createTheme} from '@mui/material/styles'

declare module '@mui/material/styles' {
    interface Palette {
        look2xBlue: Palette['primary'];
    }

    interface PaletteOptions {
        look2xBlue?: PaletteOptions['primary'];
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        look2xBlue: true;
    }
}

declare module '@mui/material/SvgIcon' {
    interface SvgIconPropsColorOverrides {
        look2xBlue: true;
    }
}

const primaryColor = {
    main: '#a0aed9',
    contrastText: '#ffffff'
}

const look2xBlue = {
    main: '#0E2445',
    contrastText: '#ffffff'
}


let theme = createTheme({
    palette: {
        primary: primaryColor,

    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '20px',
                },

            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: "20px 40px",
                    textAlign: "left",
                    color: "black",
                },
                title: {
                    fontSize: "1rem",
                    fontFamily: "Oswald"
                }
            }
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    margin: "auto"
                }
            }
        }
    }
})

export const muiTheme = createTheme(theme, {
    palette: {
        click: theme.palette.augmentColor({
            color: {
                main: "#66B3FF",
            },
            name: 'click'
        }),
        interaction: theme.palette.augmentColor({
            color: {
                main: "#FFB666",
            },
            name: 'interaction'
        }),
        reporting: theme.palette.augmentColor({
            color: {
                main: "#005CB8",
            },
            name: 'reporting'
        }),
        look2xBlue: theme.palette.augmentColor({
            color: look2xBlue,
            name: 'look2xBlue'
        }),
    }
})
